// Зріз «Руху товарів і послуг»: фільтр і сортування — одні для екрана й Excel, щоб файл відтворював те,
// що бачить користувач (docs/goods-services-movement-plan.md, етап 1 B)

export const SORT_KEYS = ["code", "inflowQty", "inValue", "qtyOut", "outValue", "balanceQty", "balance", "balanceVat", "turnover"];
export const TEXT_SORT = new Set(["code"]);
export const DEFAULT_SORT = { key: "turnover", dir: "desc" };

// Кількість кількох одиниць (null) — завжди в кінці; коди — посимвольно (2710… < 43.21… < 4818…)
export function compareMovement(a, b, { key, dir }) {
  const x = a[key], y = b[key];
  if (x == null || y == null) return x == null && y == null ? 0 : x == null ? 1 : -1;
  const c = typeof x === "string" ? (x < y ? -1 : x > y ? 1 : 0) : x - y;
  return dir === "desc" ? -c : c;
}

// opts: q — код або назва; kind — all | uktzed | dkpp; risk — all | in | out (перелік ДПС № 67);
// nonzero — лише з ненульовим залишком; sort — { key, dir }
export function filterSortMovement(rows, { q = "", kind = "all", risk = "all", nonzero = false, sort = DEFAULT_SORT } = {}) {
  const t = String(q).trim().toLowerCase();
  const s = SORT_KEYS.includes(sort?.key) ? { key: sort.key, dir: sort.dir === "asc" ? "asc" : "desc" } : DEFAULT_SORT;
  return rows.filter((x) => (!nonzero || x.units.some((u) => Math.abs(u.balanceQty) > 0.0001) || Math.abs(x.balance) > 0.005)
    && (kind === "all" || x.kind === kind)
    && (risk === "all" || (risk === "in" ? x.risky : !x.risky))
    && (!t || String(x.code).includes(t) || String(x.name).toLowerCase().includes(t) || String(x.fullName || "").toLowerCase().includes(t)))
    .sort((a, b) => compareMovement(a, b, s) || String(a.code).localeCompare(String(b.code)));
}
